import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const collaboratorsRoutes: RouteObject[] = [
  {
    path: ROUTES.COLLABORATORS.LIST,
    element: (
      <PrivateRoute>
        <Pages.Collaborators />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.COLLABORATORS.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddCollaborator />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.COLLABORATORS.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditCollaborator />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.COLLABORATORS.VIEW(':id'),
    element: (
      <PrivateRoute>
        <Pages.ViewCollaborator />
      </PrivateRoute>
    ),
  },
]

export default collaboratorsRoutes
